const customButtonType = {
    CUSTOM_ALERT : 'customAlert',

    ENDORSEMENT_BUTTON_TYPE : 'endorsement',

    POLICY_ISSUANCE_BUTTON_TYPE : 'issuance',

    POLICY_REWRITE_BUTTON_TYPE : 'rewrite',

    QUOTE_BUTTON_TYPE : 'quote',

    SUBMISSION_OVERVIEW_BUTTON_TYPE : 'overview'

};

angular.module('gw-um-j2js')
    .constant('customButtonType', customButtonType);